import styled from 'styled-components'
import { UserAvatar } from 'src/components'

export const Image = styled(UserAvatar)`
  margin-top: 0.3125rem !important;
`

Image.displayName = 'Image'
